"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import type { HealthInfoListItem } from "@/entities/health-info/model/types";
import { getHealthInfoRelatedHospital } from "@/entities/health-info/lib/seo";
import { getSafeImageSrc } from "@/shared/utils/image";
export function HealthInfoImage(t0) {
  const $ = _c(14);
  const {
    src,
    title,
    detail: t1
  } = t0;
  const detail = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== src) {
    t2 = getSafeImageSrc(src, "");
    $[0] = src;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const safeSrc = t2;
  const [failedSrc, setFailedSrc] = useState(null);
  if (!safeSrc || failedSrc === safeSrc) {
    const t3 = detail ? "aspect-video w-full rounded-lg bg-gray-100" : "size-full bg-gray-100";
    const t4 = `${title} 이미지 없음`;
    let t5;
    if ($[2] !== t3 || $[3] !== t4) {
      t5 = <div className={t3} role="img" aria-label={t4} />;
      $[2] = t3;
      $[3] = t4;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    return t5;
  }
  const t3 = detail ? 720 : 80;
  const t4 = detail ? 405 : 80;
  let t5;
  if ($[5] !== safeSrc) {
    t5 = () => setFailedSrc(safeSrc);
    $[5] = safeSrc;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = detail ? "h-auto w-full rounded-lg object-cover" : "size-full object-cover";
  let t7;
  if ($[7] !== safeSrc || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== title) {
    t7 = <Image src={safeSrc} alt={title} width={t3} height={t4} onError={t5} className={t6} />;
    $[7] = safeSrc;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = title;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
export default function HealthInfoCard(t0) {
  const $ = _c(24);
  const {
    item,
    locale
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = getHealthInfoRelatedHospital(item);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const relatedHospital = t1;
  let t2;
  if ($[2] !== item.publishedAt) {
    t2 = item.publishedAt?.match(/^(\d{4})-(\d{2})-(\d{2})/);
    $[2] = item.publishedAt;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const dateParts = t2;
  const publishedDate = dateParts ? `${dateParts[1]}. ${Number(dateParts[2])}. ${Number(dateParts[3])}` : null;
  const t3 = `/${locale}/health-info/${item.id}`;
  let t4;
  if ($[4] !== item.title) {
    t4 = <h2 className="line-clamp-2 min-h-11 break-words text-base font-semibold leading-[22px] text-gray-800">{item.title}</h2>;
    $[4] = item.title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== relatedHospital) {
    t5 = relatedHospital && <p className="min-w-0 break-words text-gray-600">관련 병원 · {relatedHospital.name}</p>;
    $[6] = relatedHospital;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.publishedAt || $[9] !== publishedDate) {
    t6 = publishedDate && <time dateTime={item.publishedAt} className="tracking-[-0.28px] text-gray-300">{publishedDate}</time>;
    $[8] = item.publishedAt;
    $[9] = publishedDate;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="mt-4 flex flex-wrap gap-x-2 gap-y-1 text-sm leading-[22px]">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className="min-w-0 flex-1 pt-1">{t4}{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== item.thumbnailUrl || $[18] !== item.title) {
    t9 = <div className="size-20 shrink-0 overflow-hidden rounded-lg bg-gray-100"><HealthInfoImage src={item.thumbnailUrl} title={item.title} /></div>;
    $[17] = item.thumbnailUrl;
    $[18] = item.title;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t8 || $[22] !== t9) {
    t10 = <Link href={t3} className="flex min-h-32 items-center gap-2 py-5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-600">{t8}{t9}</Link>;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}